module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/marketplace-644b4baa2b072f6c38d7ff3d8ed8733f.png";